export const HOST_AUTO_SERVER = process.env.REACT_APP_HOST_AUTO_SERVER + process.env.REACT_APP_PROXY_PATH;
export const HOST_SOCKET_SERVER = process.env.REACT_APP_HOST_AUTO_SERVER
export const PATH_SOCKET_SERVER = process.env.REACT_APP_PROXY_PATH + '/socket.io'
export const TOKEN_INFO_URI = '/api/playtoken/info';
export const LOGIN_TOKEN_INFO_URI = '/api/playtoken/tokenInfo';
export const START_GAME_URI = '/api/playtoken/startGame';
export const STOP_GAME_URI = '/api/playtoken/stopGame';
export const CHECK_ACCOUNT_URI = '/api/playtoken/v2/checkAccount';
export const CHECK_COOKIE_URI = '/api/playtoken/checkCookie';
export const GET_PLAYER_SETTING_URI = '/api/playtoken/getPlayerSetting';
export const POST_PLAYER_SETTING_URI = '/api/playtoken/configPlayer';
export const POST_START_FARM_HAI_SAN_URI = '/api/playtoken/startSeaFood';
export const POST_START_QUOC_CHIEN_URI = '/api/playtoken/startQuocChien';
export const POST_SELL_EQUIPMENT_URI = '/api/playtoken/sellEquipments';
export const POST_STOP_SELL_EQUIPMENT_URI = '/api/playtoken/stopSellEquipments';
export const POST_START_AUTO_TRUC_LOC_URI = '/api/playtoken/startTrucLoc';
export const POST_STOP_AUTO_TRUC_LOC_URI = '/api/playtoken/stopTrucLoc';
